module.exports = __webpack_public_path__ + "img/full.deabe446.svg";